import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Button, Image } from 'components/ui';

/**
 * Klarna Pill Button - Release 4 Style
 * Renders as a pill-shaped button with Klarna logo
 */
const KlarnaPill = props => {
    const {
        isKlarnaEnabledForThisOrder, handlePaymentClick, width, height, imageHeight
    } = props;

    // Don't render if Klarna is not enabled
    if (!isKlarnaEnabledForThisOrder) {
        return null;
    }

    return (
        <Button
            variant='primary'
            onClick={handlePaymentClick}
            data-at={Sephora.debug.dataAt('klarna_button')}
            aria-label='Pay with Klarna'
            css={styles}
            height={height || 44}
            minHeight={height || 44}
            width={width || ['151px', '151px', '100%']}
        >
            <Image
                src='/img/ufe/logo-klarna.svg'
                alt=''
                aria-hidden='true'
                height={imageHeight || '24px'}
            />
        </Button>
    );
};

const styles = {
    backgroundColor: '#FFB3C7',
    borderRadius: '22px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 24px',
    gap: '12px',
    flexShrink: 0,
    '&:hover': {
        backgroundColor: '#FFC4D4'
    }
};

export default wrapFunctionalComponent(KlarnaPill, 'KlarnaPill');
